import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { POST_HEADERS } from '../../config/constants';
import { OV_EMS_CDN } from '../../config/theme';
export var CART_UPDATED = 'OV:cartUpdated';
export var CART_ADDED = 'OV:cartAdded';
export var CART_URLS = {
  ADD: '/cart/add.js',
  CHANGE: '/cart/change.js',
  GET: '/cart.js',
  UPDATE: '/cart/update.js'
};
export var CHECKOUT_URL = '/checkout';
export var DT_HAT_ID = 17717330693;
export var DT_HAT_PRICE = 25;
export var shopifyFetchOptions = _objectSpread(_objectSpread({}, POST_HEADERS), {}, {
  credentials: 'include'
});
export var fetchOptions = _objectSpread({}, shopifyFetchOptions);
export var DG_GC_SKU = 'DGCOV';
export var PHYS_GC_SKU = 'PGCOV';
export var TEXT = {
  confirmLeave: "We're still processing your cart. Are you sure you want to leave?",
  cancel: 'Keep it',
  checkout: 'Checkout',
  confirm: 'Remove',
  remove: {
    confirm: "\n      Are you sure you don't want to try this out?",
    confirmKit: 'Removing an item means you no longer qualify for the OV Kit discount.',
    title: 'Remove from Cart',
    titleKit: 'Remove this OV Kit from your cart?'
  }
};
export var giftWrapItem = {
  id: 32720498163790,
  properties: {},
  quantity: 1,
  variant_id: 32720498163790,
  title: 'OV Gift Box - Blue / OS',
  price: 500,
  original_price: 500,
  discounted_price: 500,
  line_price: 500,
  original_line_price: 500,
  total_discount: 0,
  discounts: [],
  sku: 'OV-GIFTBOX',
  grams: 136,
  vendor: 'Outdoor Voices',
  taxable: true,
  product_id: 4870426296398,
  product_has_only_default_variant: false,
  gift_card: false,
  final_price: 500,
  final_line_price: 500,
  url: '',
  featured_image: {
    aspect_ratio: 0.75,
    alt: 'OV Gift Box',
    height: 1200,
    url: "".concat(OV_EMS_CDN, "media/products/gift-card/gift-box.jpg"),
    width: 900
  },
  image: "".concat(OV_EMS_CDN, "media/products/gift-card/gift-box.jpg"),
  handle: '',
  inventory: {
    available: true,
    inventory_policy: true,
    inventory_quantity: 17
  },
  requires_shipping: true,
  product_type: '',
  product_title: 'Gift Box + White Ribbon',
  product_description: '',
  variant_title: 'Blue / OS',
  variant_options: ['Blue', 'OS'],
  options_with_values: [{
    name: 'Color',
    value: 'Blue'
  }, {
    name: 'Size',
    value: 'OS'
  }],
  line_level_discount_allocations: [],
  line_level_total_discount: 0
};
export var MAX_RECOMMENDATIONS = 3;